import { isNotEmptyString, isNullOrUndefined } from '@weft/utils';
import { get } from 'lodash';
import type { FieldPath, FieldValues } from 'react-hook-form';
import { ERROR_NOTIFICATION_TYPES } from '../error-notification-types/error-notification-type';

export function useErrorNotificationAdapter<
  FormInput extends FieldValues,
>(errorsFields: FieldPath<FormInput>[], errors: unknown) {
  const errorsMessages = errorsFields.map((field) => {
    return {
      ...get(errors, field.toString()),
      fieldPath: field,
    };
  }).filter(errorMessage => isNotEmptyString(errorMessage.message));

  return errorsMessages.map(errorMessage => {
    if (isNullOrUndefined(errorMessage.ref)) {
      return {
        type: ERROR_NOTIFICATION_TYPES.Descriptor,
        message: errorMessage.message,
      };
    }

    return {
      type: ERROR_NOTIFICATION_TYPES.FormNavigator,
      message: errorMessage.message,
      fieldPath: errorMessage.fieldPath,
    };
  });
}